import React from 'react'
import styled from 'styled-components'
import 'font-awesome/css/font-awesome.css'
import media from '../styles/media'
import { FormattedMessage, injectIntl } from 'gatsby-plugin-intl'

const Container = styled.div`
  .titleHome {
    color: #0000e2;
    font-size: 35px;
    font-family: 'Prelo Slab';
    text-align: center;
  }
  .talk {
    display: block;
  }

  .paragraph {
    margin-left: 20%;
    margin-right: 20%;
    font-family: 'Prelo-Book';
    color: #6f6f6e;
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
    ${media.sm`
      margin-left: 10%;
      margin-right: 10%;
     `};
  }

`
const Somos = () => {
  return (
    <Container className="text-center">
      <span className="titleHome talk">
        <FormattedMessage id="somosTitle1" />
      </span>
      <span className="titleHome talk">
        <FormattedMessage id="somosTitle2" />
      </span>
      <p className="paragraph">
        <FormattedMessage id="somosDescripcion" />
      </p>
    </Container>
  )
}

export default injectIntl(Somos)
